var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfessional(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.678,
    height: 76.96,
    viewBox: "0 0 75.678 76.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "professional",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8998",
    "data-name": "Group 8998",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8997",
    "data-name": "Group 8997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20330",
    "data-name": "Path 20330",
    d: "M49.191,47.492,36.07,44.406V35.365c.112-.087.227-.165.337-.257a20.377,20.377,0,0,0,7.3-14.585h.062a1.283,1.283,0,0,0,1.283-1.283V17.957a17.958,17.958,0,0,0-35.915,0v2.565a1.283,1.283,0,0,0,1.283,1.283,1.291,1.291,0,0,0,.156-.024,20.409,20.409,0,0,0,7.2,13.327c.109.091.226.169.337.257v9.042L4.992,47.492A1.283,1.283,0,0,0,4,48.742V75.678a1.283,1.283,0,0,0,1.283,1.283H48.9a1.283,1.283,0,0,0,1.283-1.283V48.742A1.283,1.283,0,0,0,49.191,47.492ZM18.113,74.4H6.568V49.758l11.544-2.715ZM11.7,17.957a15.392,15.392,0,0,1,30.785,0H38.636a6.421,6.421,0,0,1-6.413-6.413,1.282,1.282,0,0,0-1.561-1.253l-.77.172A55.18,55.18,0,0,0,11.7,18.095ZM33.5,74.4H20.678V50.949l4.546-1.515-3.218,11.8a1.282,1.282,0,0,0,.09.911l3.848,7.7a1.283,1.283,0,0,0,2.295,0l3.848-7.7a1.282,1.282,0,0,0,.09-.911l-3.218-11.8L33.5,50.949ZM20.678,48.244V45.686l3.069,1.539Zm6.413,4.089,2.482,9.1L27.091,66.4l-2.482-4.963ZM33.5,48.244l-3.069-1.026L33.5,45.686Zm0-5.427-6.413,3.207-6.413-3.207V36.98a14.449,14.449,0,0,0,12.827,0ZM19.42,33.137a17.837,17.837,0,0,1-6.379-12.845A52.615,52.615,0,0,1,29.8,13.117a8.994,8.994,0,0,0,8.84,7.406h2.5a17.811,17.811,0,0,1-6.375,12.614A11.982,11.982,0,0,1,19.42,33.137ZM47.614,74.4H36.07V47.042l11.544,2.715Z",
    transform: "translate(-4.003 0)",
    fill: "#00acb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9000",
    "data-name": "Group 9000",
    transform: "translate(11.544 20.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8999",
    "data-name": "Group 8999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20331",
    "data-name": "Path 20331",
    d: "M97.809,128h-7.7a1.283,1.283,0,0,0-1.283,1.283v1.283H86.265v-1.283A1.283,1.283,0,0,0,84.982,128h-7.7A1.283,1.283,0,0,0,76,129.283v5.131a1.283,1.283,0,0,0,1.283,1.283h7.7a1.283,1.283,0,0,0,1.283-1.283v-1.283H88.83v1.283a1.283,1.283,0,0,0,1.283,1.283h7.7a1.283,1.283,0,0,0,1.283-1.283v-5.131A1.283,1.283,0,0,0,97.809,128ZM83.7,133.131H78.568v-2.565H83.7Zm12.827,0H91.4v-2.565h5.131Z",
    transform: "translate(-76.003 -128)",
    fill: "#00acb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9002",
    "data-name": "Group 9002",
    transform: "translate(39.764 15.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9001",
    "data-name": "Group 9001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20332",
    "data-name": "Path 20332",
    d: "M287.49,112.592a2.376,2.376,0,0,0-.569-.569v0l-2.673-1.886,1.37-2.971a2.374,2.374,0,0,0-1.943-3.362l-3.255-.292-.294-3.258a2.376,2.376,0,0,0-3.358-1.938L273.8,99.684l-1.887-2.674a2.377,2.377,0,0,0-3.881,0l-1.886,2.673-2.975-1.37a2.374,2.374,0,0,0-3.362,1.943l-.292,3.255-3.258.294a2.376,2.376,0,0,0-1.938,3.358l1.371,2.968-2.673,1.886a2.377,2.377,0,0,0,0,3.881l2.673,1.886-1.371,2.976a2.374,2.374,0,0,0,1.943,3.362l3.255.292.294,3.258a2.378,2.378,0,0,0,1.178,1.841v15.233a1.283,1.283,0,0,0,2.19.907l6.789-6.789,6.789,6.789a1.283,1.283,0,0,0,2.19-.907V129.513a2.379,2.379,0,0,0,1.177-1.843l.292-3.255,3.258-.294a2.375,2.375,0,0,0,1.942-3.361l-1.371-2.968,2.674-1.887A2.377,2.377,0,0,0,287.49,112.592ZM276.383,141.65l-5.507-5.507a1.283,1.283,0,0,0-1.814,0l-5.507,5.507V129.436l2.587-1.2,1.887,2.674a2.377,2.377,0,0,0,3.881,0l1.886-2.673,2.586,1.194Zm6.257-25.866a2.37,2.37,0,0,0-.786,2.939l1.328,2.867-3.144.283a2.374,2.374,0,0,0-2.156,2.152l-.286,3.149-2.864-1.325a2.376,2.376,0,0,0-2.939.785l-1.823,2.582-1.821-2.583a2.372,2.372,0,0,0-2.939-.786l-2.867,1.328-.283-3.144a2.374,2.374,0,0,0-2.152-2.156l-3.149-.286,1.325-2.864a2.37,2.37,0,0,0-.785-2.939l-2.582-1.823,2.583-1.821a2.37,2.37,0,0,0,.786-2.939l-1.328-2.867,3.144-.283a2.374,2.374,0,0,0,2.156-2.152l.283-3.146,2.864,1.325a2.369,2.369,0,0,0,2.939-.785l1.825-2.585,1.821,2.583a2.372,2.372,0,0,0,2.939.786l2.867-1.328.283,3.144a2.374,2.374,0,0,0,2.152,2.156l3.146.283-1.325,2.864a2.37,2.37,0,0,0,.785,2.939l2.585,1.825Z",
    transform: "translate(-252.014 -96.005)",
    fill: "#00acb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9004",
    "data-name": "Group 9004",
    transform: "translate(46.176 21.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9003",
    "data-name": "Group 9003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20333",
    "data-name": "Path 20333",
    d: "M303.547,136a11.544,11.544,0,1,0,11.544,11.544A11.544,11.544,0,0,0,303.547,136Zm0,20.523a8.979,8.979,0,1,1,8.979-8.979A8.979,8.979,0,0,1,303.547,156.523Z",
    transform: "translate(-292.003 -136)",
    fill: "#00acb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9006",
    "data-name": "Group 9006",
    transform: "translate(65.723 8.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9005",
    "data-name": "Group 9005",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_736",
    "data-name": "Rectangle 736",
    width: 2.488,
    height: 3.111,
    fill: "#00acb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9008",
    "data-name": "Group 9008",
    transform: "translate(70.7 8.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9007",
    "data-name": "Group 9007",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_737",
    "data-name": "Rectangle 737",
    width: 2.488,
    height: 3.111,
    fill: "#00acb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9010",
    "data-name": "Group 9010",
    transform: "translate(68.212 6.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9009",
    "data-name": "Group 9009",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_738",
    "data-name": "Rectangle 738",
    width: 2.488,
    height: 2.488,
    fill: "#00acb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9012",
    "data-name": "Group 9012",
    transform: "translate(68.212 11.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9011",
    "data-name": "Group 9011",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_739",
    "data-name": "Rectangle 739",
    width: 2.488,
    height: 2.488,
    fill: "#00acb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9014",
    "data-name": "Group 9014",
    transform: "translate(51.414 2.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9013",
    "data-name": "Group 9013",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_740",
    "data-name": "Rectangle 740",
    width: 2.488,
    height: 2.488,
    fill: "#00acb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9016",
    "data-name": "Group 9016",
    transform: "translate(56.391 2.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9015",
    "data-name": "Group 9015",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_741",
    "data-name": "Rectangle 741",
    width: 2.488,
    height: 2.488,
    fill: "#00acb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9018",
    "data-name": "Group 9018",
    transform: "translate(53.903 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9017",
    "data-name": "Group 9017",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_742",
    "data-name": "Rectangle 742",
    width: 2.488,
    height: 2.488,
    fill: "#00acb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9020",
    "data-name": "Group 9020",
    transform: "translate(53.903 4.977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9019",
    "data-name": "Group 9019",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_743",
    "data-name": "Rectangle 743",
    width: 2.488,
    height: 2.488,
    fill: "#00acb1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessional);
export default __webpack_public_path__ + "static/media/professional.297f08aafee2be52c63df8c7cd87d1a8.svg";
export { ForwardRef as ReactComponent };